import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { OperationType } from "../enums";

interface Props {
  type: OperationType;
  style?: React.CSSProperties;
}

export const OperationTypeTag = ({ type, style }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (type) {
    case OperationType.CALCULATE:
      color = "blue";
      break;
    case OperationType.RECALCULATE:
      color = "green";
      break;
    case OperationType.GENERATE:
      color = "magenta";
      break;
  }

  return (
    <Tag color={color} style={style}>
      {t("calc.records.enums.operationType." + type)}
    </Tag>
  );
};
